import { THEME_COLORS } from "../../../../context/constants";

const LockIcon: React.FC = () => {
  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        opacity: 1,
        pointerEvents: "none",
        zIndex: 3,
      }}
    >
      <svg
        width="84"
        height="66"
        viewBox="0 0 84 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M42 0C30.954 0 22 8.954 22 20V26H18C14.686 26 12 28.686 12 32V58C12 61.314 14.686 64 18 64H66C69.314 64 72 61.314 72 58V32C72 28.686 69.314 26 66 26H62V20C62 8.954 53.046 0 42 0ZM42 8C48.618 8 54 13.382 54 20V26H30V20C30 13.382 35.382 8 42 8ZM42 36C44.208 36 46 37.792 46 40C46 41.104 45.104 42 44 42V48C44 50.208 42.208 52 40 52C37.792 52 36 50.208 36 48V42C34.896 42 34 41.104 34 40C34 37.792 35.792 36 38 36H42Z"
          fill={THEME_COLORS.yellow}
        />
      </svg>
    </div>
  );
};

export default LockIcon;
